module.exports = __webpack_public_path__ + "media/images/android-chrome-256x256-7b2edd21593a09a2d579610bb0a19e11.png";